@if (isLogged() && disponible()) {
  @if (!isOpen()) {
    <button type="button" class="lia-bubble" (click)="toggle()" aria-label="Abrir LIA, el asistente de Libre Salud">
      <svg class="lia-bubble-svg" viewBox="0 0 24 24" width="26" height="26" fill="currentColor" aria-hidden="true">
        <!-- Destello de IA: chispa principal + 2 mini-chispas que titilan en las esquinas
             vacías (el path base está centrado en su propio (0,0) para que escalar no lo
             desplace — por eso cada chispa es translate(...) scale(...), en ese orden). -->
        <g opacity="1">
          @if (animarIcono) {
            <animate attributeName="opacity" values="1;1;0;0;1" keyTimes="0;0.55;0.62;0.9;1" dur="6s" repeatCount="indefinite" />
          }
          <g transform="translate(12,12) scale(0.8)">
            <g>
              @if (animarIcono) {
                <animateTransform attributeName="transform" type="scale" values="1;1.12;1" keyTimes="0;0.5;1" dur="1.6s" repeatCount="indefinite" />
              }
              <path d="M0,-10 Q3,-3 10,0 Q3,3 0,10 Q-3,3 -10,0 Q-3,-3 0,-10 Z" />
            </g>
          </g>
          <g transform="translate(18,6) scale(0.28)" opacity="0">
            @if (animarIcono) {
              <animate attributeName="opacity" values="0;1;0" keyTimes="0;0.5;1" dur="1.8s" begin="0.3s" repeatCount="indefinite" />
            }
            <path d="M0,-10 Q3,-3 10,0 Q3,3 0,10 Q-3,3 -10,0 Q-3,-3 0,-10 Z" />
          </g>
          <g transform="translate(6,18) scale(0.2)" opacity="0">
            @if (animarIcono) {
              <animate attributeName="opacity" values="0;1;0" keyTimes="0;0.5;1" dur="2.1s" begin="0.9s" repeatCount="indefinite" />
            }
            <path d="M0,-10 Q3,-3 10,0 Q3,3 0,10 Q-3,3 -10,0 Q-3,-3 0,-10 Z" />
          </g>
        </g>

        <!-- Globo de mensaje con puntitos de "escribiendo", aparece a mitad de ciclo -->
        @if (animarIcono) {
          <g opacity="0">
            <animate attributeName="opacity" values="0;0;1;1;0" keyTimes="0;0.55;0.62;0.9;1" dur="6s" repeatCount="indefinite" />
            <rect x="3" y="6" width="18" height="11" rx="4"></rect>
            <path d="M8,17 L6,21 L12,17 Z"></path>
            <circle cx="8.5" cy="11.5" r="1.1" fill="#102E47">
              <animate attributeName="opacity" values="0.25;1;0.25" keyTimes="0;0.5;1" dur="0.9s" begin="3.9s" repeatCount="indefinite" />
            </circle>
            <circle cx="12" cy="11.5" r="1.1" fill="#102E47">
              <animate attributeName="opacity" values="0.25;1;0.25" keyTimes="0;0.5;1" dur="0.9s" begin="4.05s" repeatCount="indefinite" />
            </circle>
            <circle cx="15.5" cy="11.5" r="1.1" fill="#102E47">
              <animate attributeName="opacity" values="0.25;1;0.25" keyTimes="0;0.5;1" dur="0.9s" begin="4.2s" repeatCount="indefinite" />
            </circle>
          </g>
        }
      </svg>
    </button>
  } @else {
    <div class="lia-panel">
      <div class="lia-header">
        <span class="lia-titulo"><i class="bi bi-chat-dots"></i> LIA</span>
        <div class="lia-header-acciones">
          @if (_vozService.puedeHablar()) {
            <button type="button" class="lia-header-icon" (click)="toggleLectura()"
              [attr.aria-label]="leerRespuestas() ? 'Desactivar lectura en voz alta' : 'Activar lectura en voz alta'">
              <i class="bi" [class.bi-volume-up-fill]="leerRespuestas()" [class.bi-volume-mute]="!leerRespuestas()"></i>
            </button>
          }
          <button type="button" class="lia-cerrar" (click)="cerrar()" aria-label="Cerrar">
            <i class="bi bi-x-lg"></i>
          </button>
        </div>
      </div>

      <div class="lia-mensajes" #mensajesEl>
        @if (historial().length === 0) {
          <div class="lia-mensaje lia-mensaje-assistant">
            ¡Hola! Soy LIA, el asistente de Libre Salud. Puedo ayudarte a encontrar un
            prestador o comercio cercano, buscar el precio de un medicamento, contarte el
            estado de tus turnos o pedidos, o resolver dudas sobre cómo usar la app.
            ¿En qué te ayudo?
          </div>
        }
        @for (msg of historial(); track $index) {
          <div class="lia-mensaje" [class.lia-mensaje-user]="msg.role === 'user'" [class.lia-mensaje-assistant]="msg.role === 'assistant'">
            <span>{{ msg.content }}</span>
            @if (msg.role === 'assistant' && _vozService.puedeHablar()) {
              <button type="button" class="lia-escuchar" (click)="escuchar(msg.content)" aria-label="Escuchar este mensaje">
                <i class="bi bi-volume-up"></i>
              </button>
            }
          </div>
        }
        @if (isLoading()) {
          <div class="lia-mensaje lia-mensaje-assistant lia-typing">
            LIA está escribiendo…
          </div>
        }
      </div>

      <div class="lia-input-row">
        @if (_vozService.escuchando()) {
          <!-- Modo grabando (estilo WhatsApp): tacho para cancelar + onda + contador -->
          <button type="button" class="lia-mic-cancelar" (click)="cancelarGrabacion()" aria-label="Cancelar grabación">
            <i class="bi bi-trash"></i>
          </button>
          <div class="lia-grabando">
            <span class="lia-grabando-onda">
              <span></span><span></span><span></span><span></span>
            </span>
            <span class="lia-grabando-tiempo">{{ tiempoGrabandoTexto() }}</span>
          </div>
        } @else {
          <input
            #mensajeInput
            type="text"
            class="lia-input"
            placeholder="Escribile a LIA..."
            [disabled]="isLoading()"
            (input)="mensajeTexto.set(mensajeInput.value)"
            (keyup.enter)="enviarDesde(mensajeInput)"
          />
          @if (mensajeTexto().trim().length > 0 || !_vozService.puedeEscuchar()) {
            <button type="button" class="lia-enviar" [disabled]="isLoading()" (click)="enviarDesde(mensajeInput)" aria-label="Enviar">
              <i class="bi bi-send"></i>
            </button>
          } @else {
            <button type="button" class="lia-mic" [disabled]="isLoading()" (click)="toggleMic()" aria-label="Hablarle a LIA">
              <i class="bi bi-mic"></i>
            </button>
          }
        }
      </div>
    </div>
  }
}
